import { render, staticRenderFns } from "./ValidInput.vue?vue&type=template&id=22309799&"
import script from "./ValidInput.vue?vue&type=script&lang=js&"
export * from "./ValidInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports